import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Lottie from "lottie-react";
// import { faqs } from "./acceleratedCashbackData";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ctaImage from '../../pages/mystery-box/images/bg-top.png';
import Heading from '../../pages/mystery-box/images/top-heading.png';
import Unlock from '../../pages/mystery-box/images/unlock.png';
import Bg from '../../pages/mystery-box/images/state-bg.png';
import BgImage from '../../pages/mystery-box/images/bg.png';
import Bonus from '../../pages/mystery-box/images/bonus.png';
import Gradiant from '../../pages/mystery-box/images/Gradient.png';
import ReactHtmlParser from 'html-react-parser';
import Mystery from '../../pages/mystery-box/images/image.png';
import Line from '../../pages/mystery-box/images/Line.png';
import BgtopImage from '../../pages/mystery-box/images/bgimage.png';
import Cta from '../../pages/mystery-box/images/CTA.png';
import Earn from '../../pages/mystery-box/images/earn.png';
import AJio from '../../pages/mystery-box/images/AJio.png';
import Flipkart from '../../pages/mystery-box/images/Flipkart.png';
import Myntra from '../../pages/mystery-box/images/Myntra.png';
import MamaEarth from '../../pages/mystery-box/images/MMEARTH.png';
import XYXX from '../../pages/mystery-box/images/XYXX.png';
import Shopsy from '../../pages/mystery-box/images/Shopsy.png';
import Amazon from '../../pages/mystery-box/images/amazon.png';
import Truemeds from '../../pages/mystery-box/images/Truemeds.png';
import Strch from '../../pages/mystery-box-jan/images/strch.png';
import Fitspire from '../../pages/mystery-box-jan/images/fitspire.png';
import Kopara from '../../pages/mystery-box-jan/images/kopara.png';
import Derma from '../../pages/mystery-box/images/Derma.png';
import Arrow from '../../pages/mystery-box/images/arrow.png';
import Bellavita from '../../pages/mystery-box-jan/images/bellavitta.png';
import { useNavigate } from 'react-router-dom';
import dor from './images/dor.png'
import Foxtale from './images/foxtale.png'
import Boat from './images/boat.png'
import Puer from './images/puer.png'
import Levis from './images/levis.png'
import Booking from './images/booking.png'
import spencer from './images/spencer.png'
import bellavita from './images/bellavita.png'
import Faq from "./component/faq";
import MysteryLogo from "./images/Mystery logo.json";





const deals = [
  {
    name: "Reliance Digital",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/reliance-digital.png",
    link: 'cashkaro://stores/reliancedigital-coupons-excl-offr-mar26',
    cashback: 'Upto 3% Cashback',
    bonus: 'Flat ₹210 Bonus',
  },
  {
    name: "SSBeauty",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ss-beauty.png",
    link: 'cashkaro://stores/ssbeauty-coupons-excl-offr-mar26',
    cashback: 'Flat 18% Cashback',
    bonus: 'Flat ₹140 Bonus',
  },
  {
    name: "Agoda",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/agoda.png",
    link: 'cashkaro://stores/agoda-excl-offr-mar26',
    cashback: 'Flat 3.5% Cashback',
    bonus: 'Flat ₹105 Bonus',
  },
  {
    name: "Croma",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/croma.png",
    link: 'cashkaro://stores/croma-excl-offr-mar26',
    cashback: 'Upto 3% Cashback',
    bonus: 'Flat ₹ 90 Bonus',
  },
  {
    name: "Muscleblaze",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/muscle-blaze.png",
    link: 'cashkaro://stores/muscleblaze-coupon-codes-excl-offr-mar26',
    cashback: 'Flat 10% Cashback',
    bonus: 'Flat ₹80 Bonus',
  },
  {
    name: "Shyaway",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/shyway.png",
    link: 'cashkaro://stores/shyaway-coupons-excl-offr-mar26',
    cashback: 'Flat 25% Cashback',
    bonus: 'Flat ₹75 Bonus',

  },
  {
    name: "Jivisa",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/jivisa.png",
    link: 'cashkaro://stores/jivisa-offers-excl-offr-mar26',
    cashback: 'Flat 65% Cashback',
    bonus: 'Flat ₹65 Bonus',

  },
  {
    name: "Koparo Clean",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/koparo.png",
    link: 'cashkaro://stores/koparoclean-coupons-excl-offr-mar26',
    cashback: 'Flat 40% Cashback',
    bonus: 'Flat ₹60 Bonus',

  },
  {
    name: "Hyugalife",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hyugalife.png",
    link: 'cashkaro://stores/hyugalife-coupons-excl-offr-mar26',
    cashback: 'Upto 10% Cashback',
    bonus: 'Flat ₹55 Bonus',

  },
  {
    name: "Nykaa",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nykaa.png",
    link: 'cashkaro://stores/nykaa-excl-offr-mar26',
    cashback: 'Upto 6% Cashback',
    bonus: 'Flat ₹50 Bonus',

  },
  {
    name: "Expedia",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/expedia.png",
    link: 'cashkaro://stores/expedia-flightbookings-excl-offr-mar26',
    cashback: 'Upto 3% Cashback',
    bonus: 'Flat ₹50 Bonus',

  },
  // {
  //   name: "Bewakoof.com",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bewakoof.png",
  //   link: 'cashkaro://stores/bewakoof-excl-offr-mar26',
  //   cashback:'Flat 18% Cashback',
  //   bonus:'Flat ₹45 Bonus',

  // },
  {
    name: "OTT Play",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ott.png",
    link: 'cashkaro://stores/ottplay-super-play-coupons-excl-offr-mar26',
    cashback: 'Flat ₹149 Cashback',
    bonus: 'Flat ₹40 Bonus',

  },
  {
    name: "Libas",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/libas.png",
    link: 'cashkaro://stores/libas-coupons-excl-offr-mar26',
    cashback: 'Flat 7% Cashback',
    bonus: 'Flat ₹40 Bonus',

  },
  {
    name: "Nutrabay",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nutrabay.png",
    link: 'cashkaro://stores/nutrabay-coupon-codes-excl-offr-mar26',
    cashback: 'Upto 10% Cashback',
    bonus: 'Flat ₹35 Bonus',

  },
  {
    name: "Clove Oral Care",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cclove.png",
    link: 'cashkaro://stores/clove-oral-care-coupons-excl-offr-mar26',
    cashback: 'Upto 75% Cashback',
    bonus: 'Flat ₹30 Bonus',

  },
  // {
  //   name: "Bajaj Prime",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/prime.png",
  //   link: 'cashkaro://stores/bajaj-prime-coupons-excl-offr-mar26',
  //   cashback:'Flat ₹625 Cashback',
  //   bonus:'Flat ₹30 Bonus',

  // },
  {
    name: "Zandu Care",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/zanduu.png",
    link: 'cashkaro://stores/zanducare-coupons-excl-offr-mar26',
    cashback: 'Flat 18% Cashback',
    bonus: 'Flat ₹30 Bonus',

  },
  {
    name: "The Derma Co",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/derma-co.png",
    link: 'cashkaro://stores/thedermaco-coupons-excl-offr-mar26',
    cashback: 'Upto 20% Cashback',
    bonus: 'Flat ₹25 Bonus',

  },
  {
    name: "Cleevo",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cleevoo.png",
    link: 'cashkaro://stores/cleevo-offers-excl-offr-mar26',
    cashback: 'Flat 30% Cashback',
    bonus: 'Flat ₹25 Bonus',

  },
  {
    name: "MamaEarth",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/mamaearth.png",
    link: 'cashkaro://stores/mama-earth-coupons-excl-offr-mar26',
    cashback: 'Upto 18% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  {
    name: "mCaffeine",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/m-caffine.png",
    link: 'cashkaro://stores/mcaffeine-coupons-excl-offr-mar26',
    cashback: 'Flat 15% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  {
    name: "Oppo",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/oppo.png",
    link: 'cashkaro://stores/oppo-coupons-excl-offr-mar26',
    cashback: 'Upto 3% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  {
    name: "Foxtale",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/foxtale.png",
    link: 'cashkaro://stores/foxtale-coupons-excl-offr-mar26',
    cashback: 'Upto 15% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  {
    name: "Dot and Key",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/dot-and-key.png",
    link: 'cashkaro://stores/dotandkey-coupons-excl-offr-mar26',
    cashback: 'Upto 15% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  {
    name: "Clovia",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/clovia.png",
    link: 'cashkaro://stores/clovia-coupons-excl-offr-mar26',
    cashback: 'Flat 12% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  {
    name: "Hyphen",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hyphen.png",
    link: 'cashkaro://stores/hyphen-coupon-codes-excl-offr-mar26',
    cashback: 'Flat 12% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  // {
  //   name: "BoAt",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/boat.png",
  //   link: 'cashkaro://stores/boat-coupon-excl-offr-mar26',
  //   cashback:'Flat 5% Cashback',
  //   bonus:'Flat ₹20 Bonus',

  // },
  {
    name: "Decathlon",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/decathlon.png",
    link: 'cashkaro://stores/decathlon-coupon-excl-offr-mar26',
    cashback: 'Flat 2.5% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  {
    name: "The Man Company",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/man-company.png",
    link: 'cashkaro://stores/themancompany-coupons-excl-offr-mar26',
    cashback: 'Upto 15% Cashback',
    bonus: 'Flat ₹20 Bonus',

  },
  {
    name: "Ajio",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ajioo.png",
    link: 'cashkaro://stores/ajio-coupons-excl-offr-mar26',
    cashback: 'Upto 8% Cashback',
    bonus: 'Upto ₹75 Bonus',

  },
  {
    name: "Truemeds",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/netmed.png",
    link: 'cashkaro://stores/truemeds-coupon-code-excl-offr-mar26',
    cashback: 'Upto ₹370 Cashback',
    bonus: 'Flat ₹15 Bonus',

  },
  {
    name: "Realme",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/realme.png",
    link: 'cashkaro://stores/realme-offers-excl-offr-mar26',
    cashback: 'Upto 5.5% Cashback',
    bonus: 'Flat ₹15 Bonus',

  },
  {
    name: "Healthkart",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/healthkart.png",
    link: 'cashkaro://stores/healthkart-excl-offr-mar26',
    cashback: 'Flat 3% Cashback',
    bonus: 'Flat ₹15 Bonus',

  },
  {
    name: "Flipkart",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/flipkartm.png",
    link: 'cashkaro://stores/flipkart-excl-offr-mar26',
    cashback: 'Upto 7% Cashback',
    bonus: 'Upto ₹75 Bonus',

  },
  {
    name: "Amazon",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/amazonm.png",
    link: 'cashkaro://stores/amazon-excl-offr-mar26',
    cashback: 'Upto 3.5% Rewards',
    bonus: 'Upto ₹75 Bonus',

  },
  {
    name: "Myntra",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/myntram.png",
    link: 'cashkaro://stores/myntra-excl-offr-mar26',
    cashback: 'Upto 6% Cashback',
    bonus: 'Upto ₹75 Bonus',

  },
  {
    name: "Firstcry",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first-cry.png",
    link: 'cashkaro://stores/firstcry-excl-offr-mar26',
    cashback: 'Upto ₹35 Cashback',
    bonus: 'Flat ₹10 Bonus',

  },

];


export default function MysteryBoxBonusNov() {

  const [alertOpen, setAlertOpen] = useState(true);
  const [message, setMessage] = useState();
  const [transaction, setTransaction] = useState(1);
  const [Reveal, setReveal] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const bonus = localStorage.getItem('mb_bonus_march_new') || 0
  const bonus_added = localStorage.getItem('mb_bonus_added_march_new') || 0
  const navigate = useNavigate()

  let checkFunction = async () => {
    let ck_id_check = localStorage.getItem('mb_ck_id_march_new')

    try {
      if (ck_id_check) {
        let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_mb_mar?ck_id=${ck_id_check}`)
        response = await response.json()
        console.log(response.user_data)
        localStorage.setItem('mb_bonus_march_new', response?.user_data?.bonus)
        localStorage.setItem('mb_bonus_added_march_new', response?.user_data?.bonus_added)
        localStorage.setItem('mb_open_march_new', response?.user_data?.claim)
        if (response?.user_data?.claim != 1) {
          navigate('/mystery-box-march-new/index', { replace: true })
        }

      } else {
        navigate('/mystery-box-march-new/index', { replace: true })
      }

    } catch (error) {
      console.log(error.message)
    }

  }

  useEffect(() => {
    checkFunction()
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleImageClick = () => {
    setReveal(true);
  };

  const showAlert = () => {
    setAlertOpen(true);
  };

  const closeAlert = () => {
    setAlertOpen(false);
  };
  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}
        sx={{
          backgroundImage: "url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bonusBG.png)",
          backgroundSize: 'contain',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#403326',
          position: 'relative',
          overflow: 'visible',
          minHeight: '100vh',
        }}>
        <Box sx={{
          position: 'relative', width: '100%',
        }}>
          <Box>
            {/* <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '60px' }}>
              <img src={Mystery} alt="Mystery" style={{ width: '212px' }} />
            </div> */}
            <div style={{ display: 'flex', justifyContent: 'center', }}>
              <Lottie
                animationData={MysteryLogo}
                loop
                autoplay
                style={{ width: "100%", }}
              />
            </div>
            <div
  style={{
    marginTop: "1rem",
    position: "relative",
    width: "100%",
    textAlign: "center",
  }}
>
  {/* Background Image */}
  <img
    src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Popupp.png"
    alt="heading"
    style={{ width: "100%", display: "block" }}
  />

  {/* Title */}
  <Typography
    sx={{
      position: "absolute",
      top: "14%",
      left: "50%",
      transform: "translateX(-50%)",
      fontFamily: "Metropolis",
      fontSize: "28px",
      fontWeight: 900,
      lineHeight: 0.95,
      textTransform: "uppercase",
      letterSpacing: "1px",
      color: "#E8D7C3",
      textShadow: `3px 4px 0px #694426, 2px 2px 4px rgba(0,0,0,0.25)`,
    }}
  >
    You <br /> got ₹{bonus}
  </Typography>

  {/* Subheading */}
  <Typography
    sx={{
      position: "absolute",
      top: "40%",
      left: "50%",
      transform: "translateX(-50%)",
      fontFamily: "Metropolis",
      fontWeight: 600,
      fontSize: "13px",
      lineHeight: "14.4px",
      color: "#8D5B1C",
      textAlign: "center",
      width: "80%",
    }}
  >
    {bonus_added == 1 ? (
      <>This Bonus Cashback has been added</>
    ) : (
      <>You have claimed your<br /> Bonus Cashback</>
    )}
  </Typography>

  {/* Description */}
  <Typography
    sx={{
      position: "absolute",
      top: "59%",
      left: "50%",
      transform: "translateX(-50%)",
      fontFamily: "Metropolis",
      fontWeight: 500,
      fontSize: "9px",
      lineHeight: "14.4px",
      color: "#694426",
      width: "85%",
      textAlign: "center",
    }}
  >
    {bonus_added == 1 ? (
      <>
        Your Bonus will be confirmed within 10 days
        <br />
        after the transaction linked to it is confirmed & validated*
      </>
    ) : (
      <>
        It may take up to 72 hours for your bonus to
        <br />
        reflect in your <b>"My Order Details"</b> section.
      </>
    )}
  </Typography>
</div>


            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <a
                href="cashkaro://my-earnings"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <img
                  src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bonusCB.png"
                  alt="Cta"
                  style={{
                    width: "80%",
                    paddingTop: "24px",
                    display: "block",
                  }}
                />
              </a>
            </div>
            <Box
              sx={{
                background: "linear-gradient(111.27deg, #F6CFB0 25.31%, #FFFFFF 74.69%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                // lineHeight: '100%',
                fontFamily: "Averia Serif Libre",
                fontWeight: 700,
                fontSize: "35px",
                textAlign: "center",
              }} mt={3}
            >
              Keep Shopping
            </Box>
            <Box>
              <Typography sx={{
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Metropolis",
                fontSize: "16px",
                fontWeight: 600,
                // lineHeight: "100%",      // 87% = 0.87 (cleaner than "87%")
                letterSpacing: "1.6px",
                textTransform: "uppercase",
              }}>earn bonus Cashback</Typography>
            </Box>
            <Box>
              <Grid container spacing={2} justifyContent="center" px={2} pt={5} mb={4}>
                {deals.map((item, index) => (
                  <Grid item xs={4} sm={4} md={4} key={index}>
                    <Box
                      sx={{
                        textAlign: "center",
                        color: "#E6D8C9",
                      }}
                    >
                      {/* Logo */}
                      <Box
                        component="img"
                        src={item.img}
                        alt={item.name}
                        sx={{
                          width: "100%",
                          objectFit: "contain",
                          mx: "auto",
                        }}
                      />

                      {/* Brand Name */}
                      <Typography
                        sx={{
                          fontSize: { xs: "10px" },
                          fontWeight: 600,
                          background: "linear-gradient(90deg, #B9A593 0%, #93785F 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          fontFamily: 'metropolis'
                        }}
                      >
                        {item.name}
                      </Typography>

                      {/* Cashback Text */}
                      <Typography
                        sx={{
                          mt: 1,
                          fontSize: "11px",
                          fontWeight: 600,
                          background: "linear-gradient(90deg, #F8DBC4 0%, #FFFFFF 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          fontFamily: 'metropolis'

                        }}
                      >
                        {item.cashback}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "11px",
                          fontWeight: 600,
                          background: "linear-gradient(90deg, #F8DBC4 0%, #FFFFFF 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          fontFamily: 'metropolis'
                        }}
                      >
                        + {item.bonus}
                      </Typography>

                      {/* Button */}
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "inline-block",
                          textDecoration: "none",
                        }}
                      >
                        <img
                          src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/shopNow.png"
                          alt="Shop Now"
                          style={{
                            width: "100%",
                            maxWidth: "180px",
                            display: "block",
                            marginTop: "10px",
                            cursor: "pointer",

                          }}
                        />
                      </a>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
            {/* {!showGrid && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  overflow: 'auto',
                }}
              >
                <a href='cashkaro://home'>
                <img
                  src={ViewMore}
                  alt="ViewMore"
                  style={{ width: '120px', paddingTop: '24px', cursor: 'pointer' }}
                  onClick={() => window.location.href='http://cashkaro.com'} // Show grid on click
                />
                </a>
              </div>
            )} */}
            {/* Render the grid when showGrid is true */}


            {/* <div style={{
              display: 'flex',
              justifyContent: 'center',
              bottom: '0',
              background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
              width: '100%',
              position: 'fixed',
              zIndex: '9999999',
              // alignItems: 'center', // Ensures vertical alignment if needed
            }}>

              <img
                src={Bonus}
                alt="Bonus"
                style={{ width: '100%' }}
              // onClick={showAlert}
              />
            </div> */}
          </Box>

          {/* Overlay Content */}
        </Box>

        {/* <Box sx={{display:'flex',justifyContent:'center',marginTop:'50px'}}>
                  <img src={dor} style={{height:'121px',width:'328px'}} />
                  </Box> */}

        <Faq />
        {/* <Alert open={alertOpen} type="success" message={message} setOpen={setAlertOpen} /> */}
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    </Grid>
  );
}
